export function keepOnlyOneBreakableSpace(str: string) {
	const halfIndex = Math.floor(str.length / 2);
	let first = str.slice(0, halfIndex);
	let second = str.slice(halfIndex);
	const firstSpaceIndex = first.lastIndexOf(' ');
	const secondSpaceIndex = second.indexOf(' ');
	const firstIndexReplacer = (matched: string, idx: number) => {
		if (idx === firstSpaceIndex) {
			return matched;
		}
		return '\u00A0';
	};
	const secondIndexReplacer = (matched: string, idx: number) => {
		if (idx === secondSpaceIndex) {
			return matched;
		}
		return '\u00A0';
	};
	if (firstSpaceIndex !== -1 && secondSpaceIndex !== -1) {
		if (halfIndex - firstSpaceIndex < secondSpaceIndex) {
			first = first.replace(/ /g, firstIndexReplacer);
			second = second.replace(/ /g, '\u00A0');
		} else {
			first = first.replace(/ /g, '\u00A0');
			second = second.replace(/ /g, secondIndexReplacer);
		}
	} else if (firstSpaceIndex !== -1) {
		first = first.replace(/ /g, firstIndexReplacer);
	} else {
		second = second.replace(/ /g, secondIndexReplacer);
	}
	return first + second;
}
